import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import logo from "../imgs/KLLogo2.png";
import MensajeModal from "../components/MensajeModal"

class HeaderComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            collapse: false,
        };

        this.toggle = this.toggle.bind(this);
        this.modalAyuda = this.modalAyuda.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
    }

    toggleCollapse() {
        this.setState({ collapse: !this.state.collapse });
    }

    modalAyuda() {
        this.setState({
            modalTitulo: "Ayuda",
            modalMensaje:
                <div>
                    <p>Este es el módulo para gestionar los turnos de atención de servicios que solicitan los usuarios de la Fundación Universitaria Konrad Lorenz.</p>
                    <p></p>
                    <p>1. Para continuar, digita tu código o cédula si eres funcionario o estudiante de la Universidad. Si eres un externo que necesita servicios de atención, por favor digita tu cédula.</p>
                    <p>2. Tu solicitud será atendida en breve, por favor quédate en la sala de espera mientras aparece tu turno en pantalla para que te dirijas a la oficina de atención asignada.</p>
                    <p>3. Tu caso será registrado de principio a fin, para así dar un seguimiento personalizado si se presenta algún inconveniente.</p>
                    <p></p>
                    <p>En el Departamento de TI de la universidad estamos atentos a tus sugerencias, recomendaciones o problemas durante este proceso.</p>
                </div>,
            modalFooter:
                <Button onClick={this.toggle} className="float-right"> Cerrar</Button>
        })
        this.toggle();
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    render() {
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <Row>
                    <Col xs="3"></Col>
                    <Col xs="6"><center><br /><img src={logo} alt="logo" /></center></Col>
                    <Col xs="3"><br /><Button color="info" onClick={this.modalAyuda}>Ayuda</Button>{' '}</Col>
                </Row>
                <br />
            </div>
        );
    }


}

export default HeaderComp;
